import React from 'react';

const Modal = ({ children, overlayStyle = {}, modalStyle = {} }) => {
  return (
    <div style={{ ...styles.overlay, ...overlayStyle }}>
      <div style={{ ...styles.modal, ...modalStyle }}>{children}</div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    background: '#fff',
    padding: '15px',
    borderRadius: '0px',
    position: 'relative',
    border: '1px solid #1A192B',
    boxShadow: '0 4px 15px rgba(0,32,96,0.35)',
  },
  closeBtn: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
  },
};

export default Modal;
